// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import PdfPreview from "../../../Common/PDFPreview";
// import { RingLoader } from 'react-spinners';
// import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount"
// import BackButton from "../../../Common/Buttons/BackButton";

// const API_URL = process.env.REACT_APP_API;

// const StockBookReportMillwise = () => {
//   const location = useLocation();
//   const companyCode = sessionStorage.getItem("Company_Code");
//   const Year_Code = sessionStorage.getItem("Year_Code");
//   const companyName = sessionStorage.getItem('Company_Name');

//   const searchParams = new URLSearchParams(location.search);
//   const itemCode = searchParams.get('itemCode');
//   const toDate = searchParams.get('toDate');
//   const fromDate = searchParams.get('fromDate');

//   const [groupedData, setGroupedData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [pdfPreview, setPdfPreview] = useState([]);
//   const [showPreview, setShowPreview] = useState(false);

//   const navigate = useNavigate();

//   const getKey = (obj, candidates) => {
//     for (const k of candidates) if (k in obj) return k;
//     return candidates[candidates.length - 1]; // fallback last
//   };

//   const groupBy = (array, keys) => {
//     // keys = ['mill_name','Mill_Name','millname'] etc.
//     if (!array || array.length === 0) return {};
//     const primaryKey = getKey(array[0], keys);

//     const grouped = array.reduce((acc, item) => {
//       const groupKey = (item[primaryKey] ?? 'Unknown').toString();
//       if (!acc[groupKey]) acc[groupKey] = [];
//       acc[groupKey].push(item);
//       return acc;
//     }, {});

//     const sortedKeys = Object.keys(grouped).sort((a, b) => a.localeCompare(b));
//     const sorted = {};
//     sortedKeys.forEach(k => (sorted[k] = grouped[k]));
//     return sorted;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
//   };

//   useEffect(() => {
//     const fetchStockBookReport = async () => {
//       try {
//         const response = await fetch(
//           `${API_URL}/report-stock-book-millwise?fromDate=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode ?? ''}&ToDate=${toDate}&Year_Code=${Year_Code}`
//         );
//         const result = await response.json();

//         const filteredData = (result.data || []).filter((item) => {
//           const docDate = new Date(item.doc_date);
//           const from = new Date(fromDate);
//           const to = new Date(toDate);
//           return docDate >= from && docDate <= to;
//         });

//         // GROUP BY MILL (supports multiple common field names)
//         const grouped = groupBy(filteredData, ["mill_name", "Mill_Name", "millname", "MillShortName"]);
//         setGroupedData(grouped);
//       } catch (error) {
//         console.error("Error fetching stock book report:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStockBookReport();
//   }, [fromDate, toDate, companyCode, Year_Code, itemCode]);

//   const handleBack = () => navigate('/stock-book');

//   const generatePDF = () => {
//     const doc = new jsPDF("landscape", "mm", "a4");
//     const pageHeight = doc.internal.pageSize.height;
//     const pageWidth = doc.internal.pageSize.width;
//     const margin = 10;

//     doc.setFontSize(14);
//     doc.setFont("helvetica", "bold");
//     const companyNameWidth = doc.getTextWidth(companyName || "Company Name");
//     doc.text(companyName || "Company Name", (pageWidth - companyNameWidth) / 2, 10);

//     doc.setFontSize(12);
//     doc.setFont("helvetica", "normal");
//     const titleWidth = doc.getTextWidth("Stock Book Report");
//     doc.text("Stock Book Report", (pageWidth - titleWidth) / 2, 18);

//     doc.setFontSize(10);
//     const dateRangeText = `From Date: ${formatDate(fromDate)} | To Date: ${formatDate(toDate)}`;
//     const dateRangeWidth = doc.getTextWidth(dateRangeText);
//     doc.text(dateRangeText, (pageWidth - dateRangeWidth) / 2, 24);

//     let currentY = 34;
//     Object.keys(groupedData).forEach((group) => {
//       if (currentY + 20 > pageHeight - margin) {
//         doc.addPage();
//         currentY = margin;
//       }

//       doc.setFontSize(12);
//       doc.setFont("helvetica", "normal");
//       const headText = `Mill: ${group.toUpperCase()}`;
//       const headWidth = doc.getTextWidth(headText);
//       doc.text(headText, (pageWidth - headWidth) / 2, currentY);
//       currentY += 10;

//       const rows = groupedData[group] || [];

//       const tableData = rows.map((row) => [
//         formatDate(row.doc_date),
//         formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2)),
//         formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2)),
//       ]);

//       const totalRow = [
//         "Total",
//         "", // opening totals not meaningful as sums; keep blank
//         "",
//         formatReadableAmount(
//           rows.reduce((sum, it) => sum + (parseFloat(it.purc_qty) || 0), 0).toFixed(2)
//         ),
//         formatReadableAmount(
//           rows.reduce((sum, it) => sum + (parseFloat(it.purc_value) || 0), 0).toFixed(2)
//         ),
//         formatReadableAmount(
//           rows.reduce((sum, it) => sum + (parseFloat(it.sale_qty) || 0), 0).toFixed(2)
//         ),
//         formatReadableAmount(
//           rows.reduce((sum, it) => sum + (parseFloat(it.sale_val) || 0), 0).toFixed(2)
//         ),
//         "", // closing totals shown line-wise; optional to compute last close
//         "",
//       ];

//       doc.autoTable({
//         startY: currentY,
//         head: [[
//           "Date",
//           "Opening Qty",
//           "Opening Value",
//           "Purchase Qty",
//           "Purchase Value",
//           "Sale Qty",
//           "Sale Value",
//           "Closing Qty",
//           "Closing Value",
//         ]],
//         body: [...tableData, totalRow],
//         styles: { fontSize: 8, cellPadding: 3, halign: "right" },
//         headStyles: { fillColor: [240, 240, 240], textColor: 0 },
//         columnStyles: { 0: { halign: "center" } },
//         didDrawPage: (data) => {
//           currentY = data.cursor.y;
//         },
//       });

//       currentY = doc.lastAutoTable.finalY + 10;
//     });

//     const pdfBlob = doc.output("blob");
//     const pdfUrl = URL.createObjectURL(pdfBlob);
//     setPdfPreview(pdfUrl);
//     setShowPreview(true);
//   };

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//         <RingLoader />
//       </div>
//     );
//   }

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <div className="d-flex mb-3 mt-0.5">
//         <BackButton onClick={handleBack} />
//         {showPreview && pdfPreview && (
//           <PdfPreview pdfData={pdfPreview} apiData={groupedData} label={"Stock-Report"} />
//         )}
//         <button
//           onClick={generatePDF}
//           className="print-button"
//           style={{ fontSize: "16px", height: "50px", marginTop: "10px" }}
//         >
//           PDF Preview
//         </button>
//       </div>

//       <h2 style={{ textAlign: "center", marginBottom: "5px", color: "#333", marginTop: "-60px" }}>
//         {companyName}
//       </h2>
//       <p style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
//         <strong>Stock Book Report From Date:</strong> {formatDate(fromDate)} |{" "}
//         <strong>To Date:</strong> {formatDate(toDate)}
//       </p>

//       {Object.keys(groupedData).map((group, index) => (
//         <div key={index} style={{ marginBottom: "30px" }}>
//           <h3 style={{ backgroundColor: "#f4f4f4", padding: "10px", textAlign: "left" }}>
//             {`MILL: ${group.toUpperCase()}`}
//           </h3>
//           <table border="1" style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
//             <thead>
//               <tr>
//                 <th rowSpan="2" style={{ textAlign: "center", padding: "10px" }}>Date</th>
//                 <th colSpan="3" style={{ textAlign: "center", padding: "10px" }}>Opening</th>
//                 <th colSpan="1" style={{ textAlign: "center", padding: "10px" }}>Purchase</th>
//                 <th colSpan="3" style={{ textAlign: "center", padding: "10px" }}>Sale</th>
//                 <th colSpan="2" style={{ textAlign: "center", padding: "10px" }}>Closing</th>
//               </tr>
//               <tr>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Quantity (in Quintals)</th>
//                 <th style={{ textAlign: "right", padding: "10px" }}>Value</th>
//               </tr>
//             </thead>
//             <tbody>
//               {(groupedData[group] || []).map((row, rowIndex) => (
//                 <tr key={rowIndex} style={{ backgroundColor: rowIndex % 2 === 0 ? "#f9f9f9" : "white" }}>
//                   <td style={{ textAlign: "center" }}>{formatDate(row.doc_date)}</td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.op_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.op_value) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.purc_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.purc_value) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.sale_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.sale_val) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.close_qty) || 0).toFixed(2))}
//                   </td>
//                   <td style={{ textAlign: "right" }}>
//                     {formatReadableAmount((parseFloat(row.close_val) || 0).toFixed(2))}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//             <tfoot style={{ backgroundColor: "#e0e0e0", fontWeight: "bold" }}>
//               <tr>
//                 <td style={{ textAlign: "center" }}>Total</td>
//                 <td />
//                 <td />
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(
//                     (groupedData[group] || []).reduce((sum, it) => sum + (parseFloat(it.purc_qty) || 0), 0).toFixed(2)
//                   )}
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(
//                     (groupedData[group] || []).reduce((sum, it) => sum + (parseFloat(it.purc_value) || 0), 0).toFixed(2)
//                   )}
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(
//                     (groupedData[group] || []).reduce((sum, it) => sum + (parseFloat(it.sale_qty) || 0), 0).toFixed(2)
//                   )}
//                 </td>
//                 <td style={{ textAlign: "right" }}>
//                   {formatReadableAmount(
//                     (groupedData[group] || []).reduce((sum, it) => sum + (parseFloat(it.sale_val) || 0), 0).toFixed(2)
//                   )}
//                 </td>
//                 <td />
//                 <td />
//               </tr>
//             </tfoot>
//           </table>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default StockBookReportMillwise;































import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import PdfPreview from "../../../Common/PDFPreview";
import { RingLoader } from "react-spinners";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import BackButton from "../../../Common/Buttons/BackButton";

const API_URL = process.env.REACT_APP_API;

/* ─── icons ─── */
const IconPDF = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);
const IconXLS = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="2" width="20" height="20" rx="2" />
    <line x1="2" y1="8" x2="22" y2="8" /><line x1="2" y1="14" x2="22" y2="14" />
    <line x1="8" y1="8" x2="8" y2="22" /><line x1="14" y1="8" x2="14" y2="22" />
  </svg>
);
const IconPrint = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6 9 6 2 18 2 18 9" />
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
    <rect x="6" y="14" width="12" height="8" />
  </svg>
);
const SortIcon = ({ direction }) => (
  <span style={{ display: "inline-flex", flexDirection: "column", marginLeft: 4, lineHeight: 1 }}>
    <span style={{ opacity: direction === "asc" ? 1 : 0.3, fontSize: 8 }}>▲</span>
    <span style={{ opacity: direction === "desc" ? 1 : 0.3, fontSize: 8 }}>▼</span>
  </span>
);

/* ─── columns ─── */
const COLUMNS = [
  { key: "doc_date", subLabel: "Date", align: "center", type: "date" },
  { key: "op_qty", subLabel: "Qty (Qtls)", align: "right", type: "number" },
  { key: "op_value", subLabel: "Value (₹)", align: "right", type: "number" },
  { key: "purc_qty", subLabel: "Qty (Qtls)", align: "right", type: "number" },
  { key: "purc_value", subLabel: "Value (₹)", align: "right", type: "number" },
  { key: "sale_qty", subLabel: "Qty (Qtls)", align: "right", type: "number" },
  { key: "sale_val", subLabel: "Value (₹)", align: "right", type: "number" },
  { key: "close_qty", subLabel: "Qty (Qtls)", align: "right", type: "number" },
  { key: "close_val", subLabel: "Value (₹)", align: "right", type: "number" },
];

/* soft pastel group span headers */
const GROUP_HEADERS = [
  { label: "Date", span: 1, bg: "#f1f5f9", color: "#64748b" },
  { label: "Opening", span: 2, bg: "#eff6ff", color: "#3b82f6" },
  { label: "Purchase", span: 2, bg: "#f0fdf4", color: "#22c55e" },
  { label: "Sale", span: 2, bg: "#fff1f2", color: "#f43f5e" },
  { label: "Closing", span: 2, bg: "#fffbeb", color: "#f59e0b" },
];

/* ─── helpers ─── */
const formatDate = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}`;
};
const fnum = (v) => (parseFloat(v) || 0).toFixed(2);

const getKey = (obj, candidates) => {
  for (const k of candidates) if (k in obj) return k;
  return candidates[candidates.length - 1];
};

const groupBy = (arr, keys) => {
  if (!arr || arr.length === 0) return {};
  const pk = getKey(arr[0], keys);
  const grouped = arr.reduce((acc, item) => {
    const k = (item[pk] ?? "Unknown").toString();
    (acc[k] = acc[k] || []).push(item);
    return acc;
  }, {});
  const sorted = {};
  Object.keys(grouped).sort((a, b) => a.localeCompare(b)).forEach((k) => { sorted[k] = grouped[k]; });
  return sorted;
};

const calcTotals = (rows) =>
  rows.reduce(
    (acc, r) => {
      acc.op_qty += parseFloat(r.op_qty) || 0;
      acc.op_value += parseFloat(r.op_value) || 0;
      acc.purc_qty += parseFloat(r.purc_qty) || 0;
      acc.purc_value += parseFloat(r.purc_value) || 0;
      acc.sale_qty += parseFloat(r.sale_qty) || 0;
      acc.sale_val += parseFloat(r.sale_val) || 0;
      acc.close_qty += parseFloat(r.close_qty) || 0;
      acc.close_val += parseFloat(r.close_val) || 0;
      return acc;
    },
    { op_qty: 0, op_value: 0, purc_qty: 0, purc_value: 0, sale_qty: 0, sale_val: 0, close_qty: 0, close_val: 0 }
  );

const compareRows = (a, b, col, dir) => {
  let va, vb;
  if (col === "doc_date") { va = new Date(a.doc_date); vb = new Date(b.doc_date); }
  else { va = parseFloat(a[col]) || 0; vb = parseFloat(b[col]) || 0; }
  return dir === "asc" ? (va > vb ? 1 : va < vb ? -1 : 0) : (va < vb ? 1 : va > vb ? -1 : 0);
};

/* ─── style helpers ─── */
const btnStyle = (bg) => ({
  display: "inline-flex", alignItems: "center", gap: 7,
  padding: "9px 18px", borderRadius: 8, border: "none", cursor: "pointer",
  fontWeight: 600, fontSize: 13, color: "#fff", background: bg,
  boxShadow: `0 2px 8px ${bg}55`, transition: "transform .15s",
  whiteSpace: "nowrap",
});
const thStyle = (align) => ({
  padding: "7px 10px", textAlign: align, background: "#f8fafc", color: "#475569",
  border: "1px solid #e2e8f0", fontWeight: 700, fontSize: 11,
  whiteSpace: "nowrap", cursor: "pointer", userSelect: "none",
});
const tdStyle = (align, even) => ({
  padding: "7px 10px", textAlign: align, color: "#1e293b",
  borderBottom: "1px solid #f1f5f9", background: even ? "#f8fafc" : "#fff",
  fontSize: 12, whiteSpace: "nowrap",
});
const tfStyle = (align, color = "#1d4ed8", bg = "#dbeafe") => ({
  padding: "8px 10px", textAlign: align, fontWeight: 700,
  background: bg, color, borderTop: "2px solid #bfdbfe", fontSize: 12,
});

/* ══════════════════════════════════════════════════════════ */
const StockBookReportMillwise = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const companyCode = sessionStorage.getItem("Company_Code");
  const Year_Code = sessionStorage.getItem("Year_Code");
  const companyName = sessionStorage.getItem("Company_Name");

  const searchParams = new URLSearchParams(location.search);
  const itemCode = searchParams.get("itemCode");
  const toDate = searchParams.get("toDate");
  const fromDate = searchParams.get("fromDate");

  const [rawGrouped, setRawGrouped] = useState({});
  const [sortState, setSortState] = useState({});
  const [loading, setLoading] = useState(true);
  const [pdfPreview, setPdfPreview] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const getSorted = useCallback((group) => {
    const rows = [...(rawGrouped[group] || [])];
    const ss = sortState[group];
    if (!ss) return rows;
    return rows.sort((a, b) => compareRows(a, b, ss.col, ss.dir));
  }, [rawGrouped, sortState]);

  const handleSort = (group, colKey) => {
    setSortState((prev) => {
      const cur = prev[group];
      const dir = cur?.col === colKey && cur.dir === "asc" ? "desc" : "asc";
      return { ...prev, [group]: { col: colKey, dir } };
    });
  };

  /* ── fetch ── */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_URL}/report-stock-book-millwise?fromDate=${fromDate}&company_code=${companyCode}&Item_Code=${itemCode ?? ""}&ToDate=${toDate}&Year_Code=${Year_Code}`);
        const result = await res.json();
        const filtered = (result.data || []).filter((item) => {
          const d = new Date(item.doc_date);
          return d >= new Date(fromDate) && d <= new Date(toDate);
        });
        setRawGrouped(groupBy(filtered, ["mill_name", "Mill_Name", "millname", "MillShortName"]));
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [fromDate, toDate, companyCode, Year_Code, itemCode]);

  /* ── PRINT — built entirely from data, never from DOM innerHTML ── */
  const handlePrint = () => {
    const groupsHTML = Object.keys(rawGrouped).map((group) => {
      const rows = getSorted(group);
      const totals = calcTotals(rows);

      const bodyRows = rows.map((row, i) => `
        <tr style="background:${i % 2 === 0 ? "#f8fafc" : "#ffffff"}">
          <td style="text-align:center;padding:5px 7px;border:1px solid #e2e8f0">${formatDate(row.doc_date)}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0">${formatReadableAmount(fnum(row.op_qty))}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0">${formatReadableAmount(fnum(row.op_value))}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0;color:#15803d">${formatReadableAmount(fnum(row.purc_qty))}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0;color:#15803d">${formatReadableAmount(fnum(row.purc_value))}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0;color:#dc2626">${formatReadableAmount(fnum(row.sale_qty))}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0;color:#dc2626">${formatReadableAmount(fnum(row.sale_val))}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0">${formatReadableAmount(fnum(row.close_qty))}</td>
          <td style="text-align:right;padding:5px 7px;border:1px solid #e2e8f0">${formatReadableAmount(fnum(row.close_val))}</td>
        </tr>`).join("");

      return `
        <div style="margin-bottom:24px">
          <div style="padding:8px 14px;background:#f0f7ff;border-left:4px solid #3b82f6;color:#1e40af;font-weight:700;font-size:12px;margin-bottom:4px">
            MILL: ${group.toUpperCase()}
          </div>
          <table style="width:100%;border-collapse:collapse;font-size:9.5px">
            <thead>
              <tr>
                <th rowspan="2" style="padding:5px 7px;background:#f1f5f9;color:#64748b;border:1px solid #e2e8f0;text-align:center;vertical-align:middle">Date</th>
                <th colspan="2" style="padding:5px 7px;background:#eff6ff;color:#3b82f6;border:1px solid #e2e8f0;text-align:center">Opening</th>
                <th colspan="2" style="padding:5px 7px;background:#f0fdf4;color:#22c55e;border:1px solid #e2e8f0;text-align:center">Purchase</th>
                <th colspan="2" style="padding:5px 7px;background:#fff1f2;color:#f43f5e;border:1px solid #e2e8f0;text-align:center">Sale</th>
                <th colspan="2" style="padding:5px 7px;background:#fffbeb;color:#f59e0b;border:1px solid #e2e8f0;text-align:center">Closing</th>
              </tr>
              <tr>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Qty (Qtls)</th>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Value (₹)</th>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Qty (Qtls)</th>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Value (₹)</th>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Qty (Qtls)</th>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Value (₹)</th>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Qty (Qtls)</th>
                <th style="padding:4px 7px;background:#f8fafc;border:1px solid #e2e8f0;text-align:right">Value (₹)</th>
              </tr>
            </thead>
            <tbody>${bodyRows}</tbody>
            <tfoot>
              <tr style="font-weight:700">
                <td style="text-align:center;padding:5px 7px;background:#dbeafe;color:#1d4ed8;border:1px solid #bfdbfe">Total</td>
                <td style="text-align:right;padding:5px 7px;background:#dbeafe;color:#1d4ed8;border:1px solid #bfdbfe">${formatReadableAmount(totals.op_qty.toFixed(2))}</td>
                <td style="text-align:right;padding:5px 7px;background:#dbeafe;color:#1d4ed8;border:1px solid #bfdbfe">${formatReadableAmount(totals.op_value.toFixed(2))}</td>
                <td style="text-align:right;padding:5px 7px;background:#dcfce7;color:#15803d;border:1px solid #bbf7d0">${formatReadableAmount(totals.purc_qty.toFixed(2))}</td>
                <td style="text-align:right;padding:5px 7px;background:#dcfce7;color:#15803d;border:1px solid #bbf7d0">${formatReadableAmount(totals.purc_value.toFixed(2))}</td>
                <td style="text-align:right;padding:5px 7px;background:#fee2e2;color:#b91c1c;border:1px solid #fecaca">${formatReadableAmount(totals.sale_qty.toFixed(2))}</td>
                <td style="text-align:right;padding:5px 7px;background:#fee2e2;color:#b91c1c;border:1px solid #fecaca">${formatReadableAmount(totals.sale_val.toFixed(2))}</td>
                <td style="text-align:right;padding:5px 7px;background:#dbeafe;color:#1d4ed8;border:1px solid #bfdbfe">${formatReadableAmount(totals.close_qty.toFixed(2))}</td>
                <td style="text-align:right;padding:5px 7px;background:#dbeafe;color:#1d4ed8;border:1px solid #bfdbfe">${formatReadableAmount(totals.close_val.toFixed(2))}</td>
              </tr>
            </tfoot>
          </table>
        </div>`;
    }).join("");

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`<!DOCTYPE html>
      <html><head>
        <title>Stock Book Report (Mill-wise) — ${companyName}</title>
        <style>
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { font-family: Arial, sans-serif; padding: 16px; color: #1e293b; }
          .report-title   { text-align: center; font-size: 17px; font-weight: 700; margin-bottom: 4px; }
          .report-subtitle { text-align: center; font-size: 13px; color: #555; font-weight: 600; margin-bottom: 4px; }
          .report-dates   { text-align: center; font-size: 11px; color: #64748b; margin-bottom: 18px; }
          @media print {
            body { padding: 8px; }
            @page { margin: 10mm; size: landscape; }
          }
        </style>
      </head>
      <body>
        <div class="report-title">${companyName || ""}</div>
        <div class="report-subtitle">Stock Book Report (Mill-wise)</div>
        <div class="report-dates">From: <strong>${formatDate(fromDate)}</strong> &nbsp;|&nbsp; To: <strong>${formatDate(toDate)}</strong></div>
        ${groupsHTML}
        <script>
          window.onload = function () {
            setTimeout(function () { window.print(); }, 300);
          };
        <\/script>
      </body></html>`);
    printWindow.document.close();
  };

  /* ── PDF ── */
  const generatePDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 10;
    let currentY = 34;

    doc.setFontSize(14); doc.setFont("helvetica", "bold");
    doc.text(companyName || "Company", pageWidth / 2, 10, { align: "center" });
    doc.setFontSize(11); doc.setFont("helvetica", "normal");
    doc.text("Stock Book Report (Mill-wise)", pageWidth / 2, 18, { align: "center" });
    doc.setFontSize(9);
    doc.text(`From Date: ${formatDate(fromDate)}   |   To Date: ${formatDate(toDate)}`, pageWidth / 2, 26, { align: "center" });

    Object.keys(rawGrouped).forEach((group) => {
      const rows = getSorted(group);
      if (currentY + 20 > pageHeight - margin) { doc.addPage(); currentY = margin; }

      doc.setFontSize(11); doc.setFont("helvetica", "bold");
      doc.setTextColor(30, 86, 219);
      doc.text(`Mill: ${group.toUpperCase()}`, pageWidth / 2, currentY, { align: "center" });
      doc.setTextColor(40);
      currentY += 8;

      const totals = calcTotals(rows);
      const tableData = rows.map((r) => [
        formatDate(r.doc_date),
        formatReadableAmount(fnum(r.op_qty)),
        formatReadableAmount(fnum(r.op_value)),
        formatReadableAmount(fnum(r.purc_qty)),
        formatReadableAmount(fnum(r.purc_value)),
        formatReadableAmount(fnum(r.sale_qty)),
        formatReadableAmount(fnum(r.sale_val)),
        formatReadableAmount(fnum(r.close_qty)),
        formatReadableAmount(fnum(r.close_val)),
      ]);
      tableData.push([
        "Total",
        formatReadableAmount(totals.op_qty.toFixed(2)),
        formatReadableAmount(totals.op_value.toFixed(2)),
        formatReadableAmount(totals.purc_qty.toFixed(2)),
        formatReadableAmount(totals.purc_value.toFixed(2)),
        formatReadableAmount(totals.sale_qty.toFixed(2)),
        formatReadableAmount(totals.sale_val.toFixed(2)),
        formatReadableAmount(totals.close_qty.toFixed(2)),
        formatReadableAmount(totals.close_val.toFixed(2)),
      ]);

      doc.autoTable({
        startY: currentY,
        head: [[
          { content: "Date", rowSpan: 2, styles: { valign: "middle", halign: "center", fillColor: [241, 245, 249], textColor: [100, 116, 139] } },
          { content: "Opening", colSpan: 2, styles: { halign: "center", fillColor: [239, 246, 255], textColor: [59, 130, 246] } },
          { content: "Purchase", colSpan: 2, styles: { halign: "center", fillColor: [240, 253, 244], textColor: [34, 197, 94] } },
          { content: "Sale", colSpan: 2, styles: { halign: "center", fillColor: [255, 241, 242], textColor: [244, 63, 94] } },
          { content: "Closing", colSpan: 2, styles: { halign: "center", fillColor: [255, 251, 235], textColor: [245, 158, 11] } },
        ], [
          "Qty (Qtls)", "Value (₹)", "Qty (Qtls)", "Value (₹)",
          "Qty (Qtls)", "Value (₹)", "Qty (Qtls)", "Value (₹)",
        ]],
        body: tableData,
        styles: { fontSize: 7.5, cellPadding: 2.5, halign: "right" },
        headStyles: { fontStyle: "bold" },
        columnStyles: { 0: { halign: "center" } },
        alternateRowStyles: { fillColor: [248, 250, 252] },
        didParseCell: (data) => {
          if (data.section === "body" && data.row.index === tableData.length - 1) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [219, 234, 254];
            data.cell.styles.textColor = [29, 78, 216];
          }
        },
        didDrawPage: (data) => { currentY = data.cursor.y; },
      });
      currentY = doc.lastAutoTable.finalY + 12;
    });

    const blob = doc.output("blob");
    setPdfPreview(URL.createObjectURL(blob));
    setShowPreview(true);
  };

  /* ── XLSX — single sheet, all mills stacked ── */
  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();
    const sheetRows = [];

    // Report info header
    sheetRows.push([companyName || ""]);
    sheetRows.push(["Stock Book Report (Mill-wise)"]);
    sheetRows.push([`From Date: ${formatDate(fromDate)}   |   To Date: ${formatDate(toDate)}`]);
    sheetRows.push([]);

    // Single column header row
    sheetRows.push([
      "Mill Name", "Date",
      "Opening Qty (Qtls)", "Opening Value (₹)",
      "Purchase Qty (Qtls)", "Purchase Value (₹)",
      "Sale Qty (Qtls)", "Sale Value (₹)",
      "Closing Qty (Qtls)", "Closing Value (₹)",
    ]);

    // All mills in one block
    Object.keys(rawGrouped).forEach((group) => {
      const rows = getSorted(group);
      const totals = calcTotals(rows);

      rows.forEach((r, i) => {
        sheetRows.push([
          i === 0 ? group : "",   // show mill name only on first row of that group
          formatDate(r.doc_date),
          parseFloat(fnum(r.op_qty)),
          parseFloat(fnum(r.op_value)),
          parseFloat(fnum(r.purc_qty)),
          parseFloat(fnum(r.purc_value)),
          parseFloat(fnum(r.sale_qty)),
          parseFloat(fnum(r.sale_val)),
          parseFloat(fnum(r.close_qty)),
          parseFloat(fnum(r.close_val)),
        ]);
      });

      // Sub-total row per mill
      sheetRows.push([
        `${group} — Total`, "",
        parseFloat(totals.op_qty.toFixed(2)),
        parseFloat(totals.op_value.toFixed(2)),
        parseFloat(totals.purc_qty.toFixed(2)),
        parseFloat(totals.purc_value.toFixed(2)),
        parseFloat(totals.sale_qty.toFixed(2)),
        parseFloat(totals.sale_val.toFixed(2)),
        parseFloat(totals.close_qty.toFixed(2)),
        parseFloat(totals.close_val.toFixed(2)),
      ]);

      sheetRows.push([]); // blank separator between mills
    });

    const ws = XLSX.utils.aoa_to_sheet(sheetRows);
    ws["!cols"] = [
      { wch: 28 }, { wch: 13 },
      { wch: 18 }, { wch: 18 },
      { wch: 18 }, { wch: 18 },
      { wch: 16 }, { wch: 16 },
      { wch: 18 }, { wch: 18 },
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Stock Book Millwise");
    XLSX.writeFile(wb, `Stock_Book_Millwise_${formatDate(fromDate).replace(/\//g, "-")}_${formatDate(toDate).replace(/\//g, "-")}.xlsx`);
  };

  /* ─── render ─── */
  if (loading) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <RingLoader color="#3b82f6" />
    </div>
  );

  return (
    <div style={{ padding: "24px 28px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", background: "#f0f4f8", minHeight: "100vh" }}>

      {/* top bar */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <BackButton onClick={() => navigate("/stock-book")} />
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {showPreview && pdfPreview && (
            <PdfPreview pdfData={pdfPreview} apiData={rawGrouped} label="Stock Book Report (Mill-wise)" />
          )}
          {/* <button style={btnStyle("#e53e3e")} onClick={generatePDF}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = ""; }}>
            <IconPDF /> PDF Preview
          </button> */}
          <button style={btnStyle("#7c3aed")} onClick={handlePrint}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = ""; }}>
            <IconPrint /> Print
          </button>
          <button style={btnStyle("#16a34a")} onClick={exportToExcel}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = ""; }}>
            <IconXLS /> Export to Excel
          </button>
        </div>
      </div>

      {/* heading */}
      <h2 style={{ textAlign: "center", fontSize: 22, fontWeight: 700, color: "#1e293b", margin: "0 0 4px" }}>
        {companyName}
      </h2>
      <p style={{ textAlign: "center", fontSize: 13, color: "#64748b", marginBottom: 20 }}>
        <strong>Stock Book Report (Mill-wise)</strong>&nbsp;&nbsp;|&nbsp;&nbsp;
        From:&nbsp;<strong>{formatDate(fromDate)}</strong>&nbsp;&nbsp;To:&nbsp;<strong>{formatDate(toDate)}</strong>
      </p>

      {/* groups */}
      {Object.keys(rawGrouped).map((group) => {
        const rows = getSorted(group);
        const totals = calcTotals(rows);
        const ss = sortState[group] || {};

        return (
          <div key={group} style={{ background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,.07)", marginBottom: 28, overflow: "hidden" }}>

            {/* ── mill header — soft, left-aligned ── */}
            <div style={{
              padding: "11px 18px",
              background: "#f0f7ff",
              borderLeft: "4px solid #3b82f6",
              borderBottom: "1px solid #dbeafe",
              color: "#1e40af",
              fontWeight: 700,
              fontSize: 14,
              letterSpacing: 0.2,
              textAlign: "left",
            }}>
              MILL: {group.toUpperCase()}
            </div>

            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr>
                    {GROUP_HEADERS.map((gh, i) => (
                      <th key={i} colSpan={gh.span}
                        style={{
                          padding: "7px 10px", textAlign: "center",
                          background: gh.bg, color: gh.color,
                          border: "1px solid #e2e8f0", fontWeight: 700, fontSize: 11
                        }}>
                        {gh.label}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {COLUMNS.map((col) => (
                      <th key={col.key} style={thStyle(col.align)}
                        onClick={() => handleSort(group, col.key)}
                        title={`Sort by ${col.subLabel}`}>
                        {col.subLabel}
                        <SortIcon direction={ss.col === col.key ? ss.dir : null} />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => (
                    <tr key={i}
                      onMouseEnter={(e) => e.currentTarget.querySelectorAll("td").forEach((td) => { td.style.background = "#eff6ff"; })}
                      onMouseLeave={(e) => {
                        const even = i % 2 === 0;
                        e.currentTarget.querySelectorAll("td").forEach((td) => { td.style.background = even ? "#f8fafc" : "#fff"; });
                      }}>
                      <td style={tdStyle("center", i % 2 === 0)}>{formatDate(row.doc_date)}</td>
                      <td style={tdStyle("right", i % 2 === 0)}>{formatReadableAmount(fnum(row.op_qty))}</td>
                      <td style={tdStyle("right", i % 2 === 0)}>{formatReadableAmount(fnum(row.op_value))}</td>
                      <td style={{ ...tdStyle("right", i % 2 === 0), color: "#15803d", fontWeight: 500 }}>{formatReadableAmount(fnum(row.purc_qty))}</td>
                      <td style={{ ...tdStyle("right", i % 2 === 0), color: "#15803d", fontWeight: 500 }}>{formatReadableAmount(fnum(row.purc_value))}</td>
                      <td style={{ ...tdStyle("right", i % 2 === 0), color: "#dc2626", fontWeight: 500 }}>{formatReadableAmount(fnum(row.sale_qty))}</td>
                      <td style={{ ...tdStyle("right", i % 2 === 0), color: "#dc2626", fontWeight: 500 }}>{formatReadableAmount(fnum(row.sale_val))}</td>
                      <td style={tdStyle("right", i % 2 === 0)}>{formatReadableAmount(fnum(row.close_qty))}</td>
                      <td style={tdStyle("right", i % 2 === 0)}>{formatReadableAmount(fnum(row.close_val))}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td style={tfStyle("center")}>Total</td>
                    <td style={tfStyle("right")}>{formatReadableAmount(totals.op_qty.toFixed(2))}</td>
                    <td style={tfStyle("right")}>{formatReadableAmount(totals.op_value.toFixed(2))}</td>
                    <td style={tfStyle("right", "#15803d", "#dcfce7")}>{formatReadableAmount(totals.purc_qty.toFixed(2))}</td>
                    <td style={tfStyle("right", "#15803d", "#dcfce7")}>{formatReadableAmount(totals.purc_value.toFixed(2))}</td>
                    <td style={tfStyle("right", "#b91c1c", "#fee2e2")}>{formatReadableAmount(totals.sale_qty.toFixed(2))}</td>
                    <td style={tfStyle("right", "#b91c1c", "#fee2e2")}>{formatReadableAmount(totals.sale_val.toFixed(2))}</td>
                    <td style={tfStyle("right")}>{formatReadableAmount(totals.close_qty.toFixed(2))}</td>
                    <td style={tfStyle("right")}>{formatReadableAmount(totals.close_val.toFixed(2))}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StockBookReportMillwise;

